<template>
  <div class="pageWrap rowJcAc">
    <audio
      ref="audio"
      id="bjSound"
      @ended.stop="audioEnded"
      autoplay
      preload="auto"
      :src="audio_url"
      controls
      @loadedmetadata="loadedmetadata"
      @timeupdate.stop="updateProgress"
    ></audio>
    <div class="contentBox colAc">
      <!-- 中间音频图标 -->
      <div class="progressWrap rowAc">
        <div class="viewName">{{ viewName }}</div>
        <div class="startTime">{{ audioData.currentTime }}</div>
        <!-- 进度条区域 -->
        <div class="progressBarBox">
          <div
            class="progressBox rowAc"
            @click="clickProgress"
            ref="progressBox"
          >
            <div
              class="progressBar"
              :style="{ width: 'calc(' + percentBar + ')' }"
              ref="progressBar"
            >
              <img src="../../static/img/slider.png" alt="" class="musicImg" />
            </div>
            <!-- <div class="progressBar" :style="{width: progressWidth}"></div> -->
            <!-- <div
              class="progressCirCle"
              @click.stop=""
              @touchmove="progressMove"
              @touchstart="touchstart"
            ></div> -->
          </div>
        </div>
        <!-- 结束时间/时长 -->
        <!-- <div class="endTime">{{ audioData.duration }}</div> -->
      </div>
      <!-- 播放暂停按钮图标 -->
      <img
        src="../../static/img/play-voice.png"
        v-if="!isPlay"
        alt=""
        class="controlImg"
        @click.stop="playsSpausesFn('play')"
      />
      <img
        src="../../static/img/pause-voice.png"
        v-else
        alt=""
        class="controlImg"
        @click.stop="playsSpausesFn('stop')"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: ["audio_url", "viewName", "audioEndedEvent", "autopaly"],
  data() {
    return {
      audioData: {
        audio_name: "20210112_1056.m4a",
        audio_url: "",
        duration: "",
        currentTime: "00:00",
        audioref: this.$refs.audio
      },
      show: true,
      // content: [           // 存放audio的地址信息，一般是接口返回
      //     {"audio_name":"20210112_1056.m4a","audio_url":"http://xuke-oss-test-first.oss-cn-shenzhen.aliyuncs.com/TTWY/TTWYXQ000001/homework/audio/79827f5c-8cde-4ccf-add4-7d47e6e20bf9.aac",duration: 0, currentTime: '00:00'},
      //     {"audio_name":"20210112_1056.m4a","audio_url":"http://xuke-oss-test-first.oss-cn-shenzhen.aliyuncs.com/TTWY/TTWYXQ000001/homework/audio/79827f5c-8cde-4ccf-add4-7d47e6e20bf9.aac",duration: 0, currentTime: '00:00'},
      // ]
      percentBar: "0%", // 进度条百分比
      isPlay: true, // 是否是播放状态
      progressBoxWidth: 0,
      progressWidth: "0px",
      touchStartX: 0, // 鼠标移动起始位置
      touchStartBarWidth: 0, // 滑块开始时的宽度,
      isLoadding: false
    };
  },
  created() {
    this.audioref = this.$refs.audio;
  },
  mounted() {
    console.log(this.audio_url);
  },
  watch: {
    isLoadding: {
      handler(c, n) {
        if (c) {
          this.plays();
        }
      }
    }
  },
  methods: {
    // 音频初始化完成获取秒数
    loadedmetadata(event) {
      // alert(event)
      this.isLoadding = true;
      this.progressBoxWidth = this.$refs.progressBox.offsetWidth;
      console.log("progressBoxWidth:", this.progressBoxWidth);
      console.log("录音时长：", event.target.duration, event);
      this.$set(
        this.audioData,
        "duration",
        this.transTime(event.target.duration - 2)
      );
      // 通过ready接口处理成功验证
      const that = this;
      wx.ready(function() {
        // 音频播放
        that.audioAutoPlay();
        // 根据个人所需
        document
          .getElementById("bjSound")
          .addEventListener("touchstart", that.audioAutoPlay);
          console.log( document
          .getElementById("bjSound"));
      });
    },
    // 音频播放位置发生改变-进度条播放的事件
    updateProgress() {
      let audio = this.$refs.audio;
      this.$nextTick(() => {
        if (audio) {
          let value = (
            (Math.floor(audio.currentTime) / Math.floor(audio.duration)) *
            100
          ).toFixed(2);
          this.$set(
            this.audioData,
            "currentTime",
            this.transTime(audio.currentTime)
          );
          this.percentBar = `${value}%`;
          console.log("音频进度条改变：", this.percentBar);
          this.progressWidth =
            Math.round(
              (Math.floor(audio.currentTime) * this.progressBoxWidth) /
                Math.floor(audio.duration)
            ) + "px";
        }
      });

      // let value = Math.round((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100, 0)
    },
    // 播放结束的处理动作
    audioEnded() {
      this.isPlay = false;
      let audio = this.$refs.audio;
      audio.currentTime = 0;
      this.$parent.audioEndedEvent();
    },
    playAudio(type) {
      console.log("type:", type);
      let audio = this.$refs.audio;
      if (type == "play") {
        this.isPlay = true;
        audio.play();
      } else {
        this.isPlay = false;
        audio.pause();
      }
    },
    plays() {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      });
      let audio = this.$refs.audio;
      this.isPlay = true;
      setTimeout(() => {
        console.log(audio);
        audio.play();
      }, 1000);
    },
    pauses() {
      let audio = this.$refs.audio;
      this.isPlay = false;
      audio.pause();
    },
    playsSpausesFn(type) {
      if (type === "stop") {
        this.playAudio("stop");
      } else {
        this.playAudio("play");
      }
    },
    audioAutoPlay() {
      let audio = document.getElementById("bjSound");
      audio.play();
    },
    onclone() {
      this.currentTime = "00:00";
      let audio = this.$refs.audio;
      audio.pause();
      this.isPlay = false;
    },
    // 点击进度条
    clickProgress(event) {
      console.log(event);
      this.progressBoxWidth = this.$refs.progressBox.offsetWidth;
      console.log("progressBoxWidth:", this.progressBoxWidth);
      console.log("点击进度条：", event);
      var duration = this.$refs.audio.duration;
      var currentTime = Math.floor(
        (event.offsetX * duration) / this.progressBoxWidth
      );
      this.$refs.audio.currentTime = currentTime;
      console.log(currentTime, "---", this.$refs.audio.currentTime);
      // this.$set(this.audioData,'currentTime',this.transTime(currentTime))
      // this.progressWidth = event.offsetX >= this.progressBoxWidth ? event.offsetX+'px' : this.progressBoxWidth+'px'
    },
    // 滑块移动
    progressMove(event) {
      console.log("滑块移动：", event);
      var duration = this.$refs.audio.duration;
      this.$set(this.audioData, "duration", this.transTime(duration));
      var currentTime = Math.floor(
        ((this.touchStartBarWidth +
          event.touches[0].clientX -
          this.touchStartX) *
          duration) /
          this.progressBoxWidth
      );
      currentTime >= duration ? duration : currentTime;
      this.$refs.audio.currentTime = currentTime;
      // this.$set(this.audioData,'currentTime',this.transTime(currentTime))
    },
    // 滑块开始触摸
    touchstart(event) {
      console.log("滑块开始触摸:", event);
      this.touchStartX = event.touches[0].clientX;
      this.touchStartBarWidth = this.$refs.progressBar.offsetWidth;
    },
    // 将秒数转化成(分:秒)格式
    transTime(time) {
      let duration = parseInt(time);
      let minute = parseInt(duration / 60)
        .toString()
        .padStart(2, "0");
      let sec = (duration % 60).toString().padStart(2, "0");
      return `${minute}:${sec}`;
    }
  }
};
</script>
<style lang="less" scoped>
.pageWrap {
  width: 100%;
  // line-height: 1.2rem;
}
.musicImg {
  width: 22px;
  height: 28px;
  position: absolute;
  right: -14px;
  top: -10px;
  z-index: 10;
}
.contentBox {
  width: 100%;
  display: flex;
  padding-right: 3px;
  box-sizing: border-box;
  align-items: center;
  height: 1.2rem;
  .nameText {
    color: #333843;
    font-size: 0.14rem;
    font-weight: 500;
    line-height: 0.21rem;
    margin-top: 0.2rem;
  }
  .progressWrap {
    position: relative;
    width: 100%;
  }
  .startTime {
    color: #333843;
    font-size: 0.12rem;
    position: absolute;
    right: 30px;
    top: -46px;
  }
  .viewName {
    color: #333843;
    font-size: 0.12rem;
    position: absolute;
    left: 1px;
    top: -46px;
  }
  .endTime {
    color: #333843;
    font-size: 0.12rem;
    line-height: 0.18rem;
    margin-right: 0.18rem;
    margin-left: 0.16rem;
  }
  .progressBarBox {
    position: relative;
    flex: 1;
    margin-right: 20px;
  }
  .progressBox {
    position: relative;
    max-width: 100%;
    // flex: 1;
    // height: .2rem;
    height: 4px;
    border-radius: 2px;
    background: #d8d8d8;
  }
  .progressBar {
    // width: calc(30%);
    max-width: 100% !important;
    height: 4px;
    border-radius: 2px;
    background: #f73846;
    position: relative;
  }
  .progressCirCle {
    position: relative;
    width: 0.2rem;
    height: 0.2rem;
    background: #ffffff;
    border: 1px solid #e6e6e8;
    border-radius: 50%;
    box-sizing: border-box;
    margin-left: -0.1rem;
  }
  .controlImg {
    width: 0.6rem;
    height: 0.6rem;
  }
}
audio {
  position: absolute;
  top: 0;
  display: block;
  height: 0;
  width: 0;
  opacity: 0;
}
// 横向排列
.flexRow {
  display: flex;
  flex-direction: row;
}
// 纵向排列
.flexCol {
  display: flex;
  flex-direction: column;
}

// 横向排列  主轴start 555555555555555555
.rowJs {
  @extend .flexRow;
  justify-content: flex-start;
}
// 横向排列  主轴between
.rowJb {
  @extend .flexRow;
  justify-content: space-between;
}
// 横向排列  主轴center
.rowJc {
  @extend .flexRow;
  justify-content: center;
}
// 横向排列  主轴around
.rowJa {
  @extend .flexRow;
  justify-content: space-around;
}
//  横向排列  主轴end
.rowJe {
  @extend .flexRow;
  justify-content: flex-end;
}

// 横向排列  副轴center
.rowAc {
  @extend .flexRow;
  align-items: center;
}
.rowAs {
  @extend .flexRow;
  align-items: flex-start;
}
.rowAe {
  @extend .flexRow;
  align-items: flex-end;
}
// 纵向排列  主轴center
.colJc {
  @extend .flexCol;
  justify-content: center;
}
// 纵向排列  副轴center
.colAc {
  @extend .flexCol;
  align-items: center;
}
// 横向排列  侧轴center  主轴center
.rowJcAc {
  @extend .rowAc;
  justify-content: center;
}
// 横向排列  副轴center  主轴between
.rowJbAc {
  @extend .rowAc;
  justify-content: space-between;
}
.rowJbAe {
  @extend .rowJb;
  align-items: flex-end;
}
.rowJaAc {
  @extend .rowJa;
  align-items: center;
}
// 纵向排列  主轴center  副轴center
.colJcAc {
  @extend .colJc;
  align-items: center;
}
.colJcAe {
  @extend .colJc;
  align-items: flex-end;
}
// 纵向排列  副轴start
.colAs {
  @extend .flexCol;
  align-items: flex-start;
}
//  横向排列  副轴center  主轴start
.rowJsAc {
  @extend .rowAc;
  justify-content: flex-start;
}
//   横向排列  主轴end  副轴center
.rowJeAc {
  @extend .rowJe;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/audioPlayer.vue